/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const inviteUsers = /* GraphQL */ `
  mutation InviteUsers($input: InviteUsersInput!) {
    inviteUsers(input: $input) {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const inviteUsersByAuth0OrganizationId = /* GraphQL */ `
  mutation InviteUsersByAuth0OrganizationId(
    $input: InviteUsersByAuth0OrganizationIdInput!
  ) {
    inviteUsersByAuth0OrganizationId(input: $input) {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const inviteMultipleUsers = /* GraphQL */ `
  mutation InviteMultipleUsers($input: InviteMultipleUsersInput!) {
    inviteMultipleUsers(input: $input) {
      statusCode
      error
      failedIds
      __typename
    }
  }
`;
export const activateUser = /* GraphQL */ `
  mutation ActivateUser($input: ActivateUserInput!) {
    activateUser(input: $input) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const updateGroupByAuth0OrganizationId = /* GraphQL */ `
  mutation UpdateGroupByAuth0OrganizationId(
    $input: UpdateGroupByAuth0OrganizationIdInput!
  ) {
    updateGroupByAuth0OrganizationId(input: $input) {
      auth0OrganizationId
      id
      name
      memberCount
      isDefault
      __typename
    }
  }
`;
export const updateGroup = /* GraphQL */ `
  mutation UpdateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      statusCode
      error
      __typename
    }
  }
`;
export const updateOrganizationByAuth0OrganizationId = /* GraphQL */ `
  mutation UpdateOrganizationByAuth0OrganizationId(
    $input: UpdateOrganizationByAuth0OrganizationIdInput!
  ) {
    updateOrganizationByAuth0OrganizationId(input: $input) {
      ... on Organization {
        auth0OrganizationId
        id
        name
        createdAt
        services {
          master {
            id
            name
            __typename
          }
          plan {
            auth0OrganizationId
            status
            master {
              id
              displayName
              __typename
            }
            __typename
          }
          licenses {
            auth0OrganizationId
            master {
              id
              name
              displayName
              type
              __typename
            }
            planMaster {
              id
              displayName
              __typename
            }
            assignmentCurrent
            assignmentLimit
            __typename
          }
          __typename
        }
        specteeContactEmail
        customerContactEmail
        customerContactName
        maxGroups
        note
        contractNumber
        planData {
          serviceId
          status
          __typename
        }
        commonSettings {
          options {
            key
            id
            checked
            usedQuantity
            __typename
          }
          licenses {
            key
            id
            quantity
            usedQuantity
            __typename
          }
          __typename
        }
        serviceSettings {
          serviceId
          startDate
          endDate
          options {
            key
            id
            checked
            usedQuantity
            __typename
          }
          licenses {
            key
            id
            quantity
            usedQuantity
            __typename
          }
          __typename
        }
      }
      ... on UserErrors {
        userErrors {
          message
          __typename
        }
      }
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const updateUserLatest = /* GraphQL */ `
  mutation UpdateUserLatest($input: UpdateUserInput!) {
    updateUserLatest(input: $input) {
      statusCode
      error
      user {
        auth0UserId
        name
        displayName
        email
        authority {
          name
          displayName
          totalQuantity
          usedQuantity
          __typename
        }
        licenses {
          id
          name
          displayName
          serviceMaster {
            id
            name
            __typename
          }
          type
          __typename
        }
        licenseData {
          serviceId
          roleId
          __typename
        }
        groups {
          auth0OrganizationId
          id
          name
          memberCount
          isDefault
          __typename
        }
        adminGroupIds
        createdAt
        __typename
      }
      __typename
    }
  }
`;
export const updateUserByAuth0OrganizationId = /* GraphQL */ `
  mutation UpdateUserByAuth0OrganizationId(
    $input: UpdateUserByAuth0OrganizationIdInput!
  ) {
    updateUserByAuth0OrganizationId(input: $input) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const updateUsers = /* GraphQL */ `
  mutation UpdateUsers($input: [UpdateUserInput!]!) {
    updateUsers(input: $input) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const updateServicesByAuth0OrganizationId = /* GraphQL */ `
  mutation UpdateServicesByAuth0OrganizationId(
    $input: [UpdateServiceByAuth0OrganizationIdInput!]!
  ) {
    updateServicesByAuth0OrganizationId(input: $input) {
      master {
        id
        name
        __typename
      }
      plan {
        auth0OrganizationId
        status
        master {
          id
          displayName
          serviceMaster {
            id
            name
            __typename
          }
          licenses {
            id
            quantity
            __typename
          }
          __typename
        }
        __typename
      }
      licenses {
        auth0OrganizationId
        master {
          id
          name
          displayName
          serviceMaster {
            id
            name
            __typename
          }
          type
          __typename
        }
        planMaster {
          id
          displayName
          serviceMaster {
            id
            name
            __typename
          }
          licenses {
            id
            quantity
            __typename
          }
          __typename
        }
        assignmentCurrent
        assignmentLimit
        __typename
      }
      __typename
    }
  }
`;
export const createOptionEvent = /* GraphQL */ `
  mutation CreateOptionEvent($input: createOptionEventInput!) {
    createOptionEvent(input: $input) {
      auth0OrganizationId
      sortKey
      masterId
      contractType
      quantity
      createdBy
      createdAt
      deletedAt
      __typename
    }
  }
`;
export const createOptions = /* GraphQL */ `
  mutation CreateOptions($input: CreateOptionsInput!) {
    createOptions(input: $input) {
      auth0OrganizationId
      sortKey
      masterId
      status
      message
      createdAt
      deletedAt
      __typename
    }
  }
`;
export const createOptionsByAuth0OrganizationId = /* GraphQL */ `
  mutation CreateOptionsByAuth0OrganizationId(
    $input: CreateOptionsByAuth0OrganizationIdInput!
  ) {
    createOptionsByAuth0OrganizationId(input: $input) {
      auth0OrganizationId
      sortKey
      masterId
      status
      message
      createdAt
      deletedAt
      __typename
    }
  }
`;
export const createGroup = /* GraphQL */ `
  mutation CreateGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      ... on Group {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
      }
      ... on UserError {
        message
      }
    }
  }
`;
export const createGroupByAuth0OrganizationId = /* GraphQL */ `
  mutation CreateGroupByAuth0OrganizationId(
    $input: CreateGroupByAuth0OrganizationIdInput!
  ) {
    createGroupByAuth0OrganizationId(input: $input) {
      ... on Group {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
      }
      ... on UserError {
        message
      }
    }
  }
`;
export const createPlanByAuth0OrganizationId = /* GraphQL */ `
  mutation CreatePlanByAuth0OrganizationId(
    $input: CreatePlanByAuth0OrganizationIdInput!
  ) {
    createPlanByAuth0OrganizationId(input: $input) {
      auth0OrganizationId
      status
      master {
        id
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        licenses {
          id
          quantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      auth0OrganizationId
      id
      name
      createdAt
      services {
        master {
          id
          name
          __typename
        }
        plan {
          auth0OrganizationId
          status
          master {
            id
            displayName
            __typename
          }
          __typename
        }
        licenses {
          auth0OrganizationId
          master {
            id
            name
            displayName
            type
            __typename
          }
          planMaster {
            id
            displayName
            __typename
          }
          assignmentCurrent
          assignmentLimit
          __typename
        }
        __typename
      }
      specteeContactEmail
      customerContactEmail
      customerContactName
      maxGroups
      note
      contractNumber
      planData {
        serviceId
        status
        __typename
      }
      commonSettings {
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      serviceSettings {
        serviceId
        startDate
        endDate
        options {
          key
          id
          checked
          usedQuantity
          __typename
        }
        licenses {
          key
          id
          quantity
          usedQuantity
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createLicensesByAuth0OrganizationId = /* GraphQL */ `
  mutation CreateLicensesByAuth0OrganizationId(
    $input: CreateLicensesByAuth0OrganizationIdInput!
  ) {
    createLicensesByAuth0OrganizationId(input: $input) {
      auth0OrganizationId
      master {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      planMaster {
        id
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        licenses {
          id
          quantity
          __typename
        }
        __typename
      }
      assignmentCurrent
      assignmentLimit
      __typename
    }
  }
`;
export const deleteUsers = /* GraphQL */ `
  mutation DeleteUsers($input: DeleteUsersInput!) {
    deleteUsers(input: $input) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const deleteUsersByAuth0OrganizationId = /* GraphQL */ `
  mutation DeleteUsersByAuth0OrganizationId(
    $input: DeleteUsersByAuth0OrganizationIdInput!
  ) {
    deleteUsersByAuth0OrganizationId(input: $input) {
      auth0UserId
      name
      displayName
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        id
        name
        displayName
        serviceMaster {
          id
          name
          __typename
        }
        type
        __typename
      }
      licenseData {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      adminGroupIds
      createdAt
      __typename
    }
  }
`;
export const deleteGroupsByAuth0OrganizationId = /* GraphQL */ `
  mutation DeleteGroupsByAuth0OrganizationId(
    $input: DeleteGroupsByAuth0OrganizationIdInput!
  ) {
    deleteGroupsByAuth0OrganizationId(input: $input) {
      statusCode
      error
      __typename
    }
  }
`;
export const deleteGroups = /* GraphQL */ `
  mutation DeleteGroups($input: DeleteGroupsInput!) {
    deleteGroups(input: $input) {
      statusCode
      error
      __typename
    }
  }
`;
export const deleteInvitations = /* GraphQL */ `
  mutation DeleteInvitations($input: DeleteInvitationsInput!) {
    deleteInvitations(input: $input) {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const deleteInvitationsByAuth0OrganizationId = /* GraphQL */ `
  mutation DeleteInvitationsByAuth0OrganizationId(
    $input: DeleteInvitationsByAuth0OrganizationIdInput!
  ) {
    deleteInvitationsByAuth0OrganizationId(input: $input) {
      email
      authority {
        name
        displayName
        totalQuantity
        usedQuantity
        __typename
      }
      licenses {
        serviceId
        roleId
        __typename
      }
      groups {
        auth0OrganizationId
        id
        name
        memberCount
        isDefault
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const deleteAllUsers = /* GraphQL */ `
  mutation DeleteAllUsers($input: DeleteAllUsersInput!) {
    deleteAllUsers(input: $input) {
      statusCode
      error
      failedIds
      __typename
    }
  }
`;
export const updateLicenses = /* GraphQL */ `
  mutation UpdateLicenses($input: UpdateLicensesInput!) {
    updateLicenses(input: $input) {
      statusCode
      error
      __typename
    }
  }
`;
export const addRemoveMembersFromGroup = /* GraphQL */ `
  mutation AddRemoveMembersFromGroup($input: AddOrRemoveGroupInput!) {
    addRemoveMembersFromGroup(input: $input) {
      statusCode
      error
      __typename
    }
  }
`;
export const updateUserDetails = /* GraphQL */ `
  mutation UpdateUserDetails($input: UserDetailsInput!) {
    updateUserDetails(input: $input) {
      statusCode
      __typename
    }
  }
`;
export const sendPasswordResetMail = /* GraphQL */ `
  mutation SendPasswordResetMail($userId: String!, $email: String!) {
    sendPasswordResetMail(userId: $userId, email: $email)
  }
`;
export const passwordReset = /* GraphQL */ `
  mutation PasswordReset {
    passwordReset
  }
`;
export const saveInquiry = /* GraphQL */ `
  mutation SaveInquiry($input: InquiryInput!) {
    saveInquiry(input: $input) {
      name
      email
      tel
      subject
      content
      companyName
      __typename
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization($id: String!) {
    deleteOrganization(id: $id) {
      statusCode
      error
      __typename
    }
  }
`;
